<template>
    <div class="custom-pagination">
      <span>Página {{ currentPage }} de {{ total }}</span>
      <el-button class="prev-next" :disabled="currentPage === 1" @click="prevPage" size="mini" icon="el-icon-arrow-left"></el-button>
      <el-input v-model="inputPage" @input="handleInputPage" class="page-input" size="small"></el-input>
      <el-button class="prev-next" :disabled="currentPage === total" @click="nextPage" size="mini" icon="el-icon-arrow-right"></el-button>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      currentPage: [Number, String],
      totalPages: Number,
      perPage: {
        type: Number,
        default: 10
      },
    },
    data() {
      return {
        inputPage: this.currentPage
      };
    },
    methods: {
      prevPage() {
        if (this.currentPage > 1) {
          this.$emit("page-change", this.currentPage - 1);
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.$emit("page-change", this.currentPage + 1);
        }
      },
      handleInputPage() {
        this.inputPage = this.inputPage.replace(/\D/g, "");
        if(this.inputPage > this.total) {
            this.inputPage = this.total
        }
        this.$emit("page-change", this.inputPage);
      },
    },
    watch: {
        currentPage(val) {
            this.inputPage = val
        }
    },
    computed: {
        total() {
            return Math.ceil(Number(this.totalPages || 0) / Number(this.perPage || 0));
        },
    },
  };
  </script>
  
  <style scoped>
  .custom-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -10px;
  }
  
  .page-input {
    width: 50px;
    text-align: center;
  }
  
  .prev-next {
        padding: 9px;
        margin: 0 15px;
    }
  </style>